import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Printer } from '@untitledui/icons';
import { toast } from 'react-toastify';
import paymentService from '../services/paymentService';
import { Button } from './untitled-ui/base/buttons/button';
import PaymentReceipt, { ReceiptProps, printReceipt } from './PaymentReceipt';

const PaymentReceiptPublic: React.FC = () => {
  const { token } = useParams();
  const [receipt, setReceipt] = useState<ReceiptProps | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    if (!token) { setLoading(false); return; }
    paymentService.getPaymentByReceiptToken(token).then(result => {
      if (active) setReceipt({ member: result.member, payment: { amount: result.amount, date: result.paymentDate, method: result.paymentMethod, transactionId: result.transactionId, timestamp: result.createdAt, notes: result.notes } });
    }).catch(() => { if (active) setReceipt(null); }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [token]);
  if (loading) return <div className="u-app-loading">Loading receipt…</div>;
  if (!receipt) return <main className="receipt-public-shell"><div className="receipt-unavailable"><h1>Receipt unavailable</h1><p>This receipt link is invalid or has expired.</p></div></main>;
  return <main className="receipt-public-shell"><div className="receipt-public-toolbar"><span>Payment receipt</span><Button color="secondary" iconLeading={Printer} onPress={() => { try { printReceipt(); } catch (error: any) { toast.error(error.message); } }}>Print / save PDF</Button></div><PaymentReceipt {...receipt} /></main>;
};
export default PaymentReceiptPublic;
